const primaryText = {
  color: '#333'
};

export {
  primaryText
};



// WEBPACK FOOTER //
// ./src/ui/styles/colors.js